export default "skymp5-front/af6071845a00d32384d1da765f5316a9.png";